import styled from "styled-components";
import { CenterFlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const OrgLogoContainer = styled.div`
  width: 42px;
  height: 42px;

  @media (max-width: 700px) {
    width: 32px;
    height: 32px;
  }
`;

export const MatchContainer = styled(CenterFlexColumn)`
  padding: ${Theme.smallPanelPadding} 20px;
  border-right: ${Theme.panelContentBorder};
  &:last-child {
    border-right: 0;
  }

  @media (max-width: 700px) {
    padding: ${Theme.smallPanelPadding} 10px;
  }

  @media (max-width: 500px) {
    padding: ${Theme.smallPanelPadding} 8px;
  }
`;

export const MatchTeamsContainer = styled(FlexRow)`
  column-gap: 8px;

  @media (max-width: 700px) {
    column-gap: 5px;
  }
`;

export const MatchPoints = styled.span`
  font-size: 13pt;
  font-weight: 500;
  margin-top: 5px;

  @media (max-width: 700px) {
    font-size: 12pt;
  }

  @media (max-width: 600px) {
    font-size: 10.5pt;
  }
`;

export const DriverPicksContainer = styled(FlexRow)`
  padding-top: "18px";
  border-top: ${Theme.panelContentBorder};
`;

export const DriverPick = styled(FlexRow)`
  flex-grow: 1;
  flex-basis: 0;
  font-size: 13pt;
  padding: 8px ${Theme.smallPanelPadding};

  border-right: ${Theme.panelContentBorder};
  &:last-child {
    border-right: 0;
  }

  @media (max-width: 700px) {
    font-size: 12pt;
    padding: 6px ${Theme.smallPanelPadding};
  }

  @media (max-width: 600px) {
    font-size: 10.5pt;
    padding: 5px ${Theme.smallPanelPadding};
  }
`;

export const DriverLogoContainer = styled.div`
  width: 18px;
  height: 20px;
  padding-right: 5px;

  @media (max-width: 700px) {
    width: 16px;
    height: 18px;
  }
`;

export const DriverName = styled.div`
  line-height: 100%;
`;

export const DriverPoints = styled.div`
  margin-left: auto;
  font-weight: 500;
`;
